import { Modal, Button, Badge } from "react-bootstrap";
import DownloadButton from "../../DownloadButton/DownloadButton";
import { useTranslation } from "react-i18next";
import "./GalleryModal.css";

function GalleryModal({ show, handleClose, item }) {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdropClassName="custom-backdrop"
      >
        <Modal.Header className="d-flex flex-column">
          <div
            className={`modal-media w-100 ${
              item?.type === "video" ? "video" : ""
            }`}
          >
            {item && item.type === "video" ? (
              item.proxyUrl ? (
                <video controls>
                  <source
                    src={item.proxyUrl || ""}
                    type="video/mp4"
                    style={{ objectFit: "contain" }}
                  />
                </video>
              ) : (
                ""
              )
            ) : item.coverUrl ? (
              <img src={item.proxyUrl || ""} alt="modal thumbnail" />
            ) : (
              ""
            )}
          </div>
          <div className="w-100 d-flex flex-row justify-content-end">
            <DownloadButton item={item} />
          </div>
        </Modal.Header>
        <Modal.Body>
          {item.downloads !== 0 ? (
            <div>
              <Badge className="position-static" bg="success">
                {item.downloads} {t("downloaded")}
              </Badge>
            </div>
          ) : (
            ""
          )}
          {item.publishingDate && (
            <div>
              <strong>{t("published_on")}:</strong>{" "}
              <Badge className="position-static" bg="secondary">
                {item.publishingDate.slice(0, 10)}{" "}
                {item.publishingDate.slice(11, 19)}
              </Badge>
            </div>
          )}
          {item.title && (
            <div>
              <strong>{t("title")}:</strong> {item.title}
            </div>
          )}
          {item.ship && (
            <div>
              <strong>{t("ship")}:</strong> {item.ship}
            </div>
          )}
          {item.onboard && (
            <div>
              <strong>{t("on_board")}:</strong>{" "}
              {Array.isArray(item.onboard)
                ? item.onboard.join(", ")
                : item.onboard}
            </div>
          )}
          {item.description && (
            <div>
              <strong>Info:</strong> {item.description}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default GalleryModal;
